import { combineReducers } from 'redux';
import domainReducer from './domain/domain.reducer';
import userReducer from './user/user.reducer';
import contactsReducer from './contacts/contacts.reducer';
import senderAccountsReducer from './senderAccounts/senderAccounts.reducer';
import attributesReducer from './attributes/attributes.reducer';
import segmentsReducer from './segments/segments.reducer';
import { segmentChangeHistoryReducer } from './segmentChangeHistory';
import apiKeysReducer from './apiKeys/apiKeys.reducer';
import campaignReducer from './campaigns/campaigns.reducer';
import workflowsReducer from './workflows/workflows.reducer';
import emailTemplatesReducer from './emailTemplates/emailTemplates.reducer';
import { emailSentHistoryReducer } from './emailSentHistory';
import { workspaceReducer } from './workspace';
import { unsubscribeGroupsReducer } from './unsubscribeGroups';
import unsubscribePreferenceReducer from './unsubscribePreference/unsubscribePreference.reducer';
import { activityReducer } from './activity';
import trackContactCreationReducer from './trackContactCreation/trackContactCreation.reducer';
import { accountsReducer } from './accounts';
import { eventsReducer } from './events';
import { eventAttributesReducer } from './eventAttributes';
import { paymentsReducer } from './payments';

const rootReducer = combineReducers({
  domain: domainReducer,
  user: userReducer,
  contacts: contactsReducer,
  senderAccounts: senderAccountsReducer,
  attributes: attributesReducer,
  segments: segmentsReducer,
  segmentChangeHistory: segmentChangeHistoryReducer,
  apiKeys: apiKeysReducer,
  campaigns: campaignReducer,
  workflows: workflowsReducer,
  emailTemplates: emailTemplatesReducer,
  emailSentHistory: emailSentHistoryReducer,
  workspace: workspaceReducer,
  unsubscribeGroups: unsubscribeGroupsReducer,
  unsubscribePreference: unsubscribePreferenceReducer,
  activity: activityReducer,
  trackContactCreation: trackContactCreationReducer,
  accounts: accountsReducer,
  events: eventsReducer,
  eventAttributes: eventAttributesReducer,
  payments: paymentsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
